import React, {useContext, useEffect, useState} from "react";
import localization from 'assets/localization/localization';
import Layout from "../../../components/sales/layout/layout";
import CustomModal from "../../valetServices/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import Images from "../../../assets/images/imageData";
import TextAreaInput from "../../../components/sales/Input/textAreaInput/textAreaInput";
import {Button} from "react-bootstrap";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import { toast } from 'react-toastify';
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';

const AddToDealerWallet = ({
                           documentUploadUrlPublic,
                           documentUrlDataPublic,
                           addMoney,
                           match,
                           addedMoney = [],
                           history,
                           fetchDealerDetails,
                           dealerData,
                           savePaymentForDealer
                       }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [dealerId, setDealerId] = useState('');
    const [dealerDetails, setDealerDeatails] = useState(null);
    const [inputList, setInputList] = useState([{
        amount: "",
        remark: "",
        dealer_id: "",
        dealer_user_id: "",
        business_id: "",
        attachment: "",
        role_id:''
    }]);
    //console.log('PAGE::ADD_TO_DEALER_WALLET');

    const handleInputChange = (e) =>{
       setDealerId(e.target.value);
    };

    const applySearchKey = async () => {
      if(dealerId != '') {
        setIsLoading(true);
        const response = await fetchDealerDetails(dealerId);
        //console.log('reponse ' + JSON.stringify(response));
        if(response && response?.data !== null) {
            setIsLoading(false);
            setDealerDeatails(response?.data);
        } else {
            setIsLoading(false);
            toast.info('Dealer not found.');
            return false;
        }    
      } else {
        toast.error('Please fill search field.');
      }
    }

    const handleInputList = (val, key) => {
        let list = [...inputList]
        list[0][key] = val
        setInputList(list)
    }

    useEffect(() => {
        if(dealerDetails !== null) {
            let list = [...inputList];
            list[0]['dealer_id'] = dealerDetails?.id;
            list[0]['dealer_user_id'] = dealerDetails?.dealer_details?.user_id;
            list[0]['business_id'] = dealerDetails?.financial_details?.business_id;
            setInputList(list)
        }
    },[dealerDetails]);

    const handleSubmitTransaction = async () => {
        if(inputList[0].amount == '' || inputList[0].amount == null) {
           toast.error('Amount field is required.');
           return false;
        }
        if(inputList[0].attachment == '' || inputList[0].remark == '') {
            toast.error('Attachment & remark field is required.');
            return false;
        }
        if(inputList[0].dealer_id == '' || inputList[0].dealer_user_id == '' || inputList[0].business_id == '') {
            toast.error('Dealer details are missing.');
            return false;
        }

        inputList[0]['role_id'] = localStorage.getItem('fusion-role')
        const payload = {
           data: inputList 
        }
        setIsLoading(true);
        const response = await savePaymentForDealer(payload);
        //console.log('reponse v1 ' + JSON.stringify(response));
        if(response && response?.data !== false) {
             setIsLoading(false);
             history.push(`${baseUrl}/dealer-wallet`);
        } else {
            setIsLoading(false);
            toast.warning('Not Saved.');
            return false;
        }
    }

    return (
        <>
            <Layout
                title={localization.searchDealer}
                isLoading={isLoading}
                isGoback={true}
            >
            <div className="container-fluid">
            <div className="col-md-12 mb-4">
                <div className="border border-primary rounded-10  searchBox" >
                <div className="input-group">
                    <input type="number" className="form-control rounded borderColorBox" onChange={e => handleInputChange(e)} placeholder="Enter Dealer Id" aria-label="Search" aria-describedby="search-addon" />
                    <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applySearchKey}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                    </svg></button>
                </div>
                </div>
            </div> 
            {dealerDetails !== null && dealerDetails !== undefined ? (
                <>
                <CardSection title={localization.dealerDeatails}>
                    <div className="details-listing">
                        <DivLayout
                            heading={`Dealer Id`}
                            data={dealerDetails?.id}
                        />
                        <DivLayout
                            heading={`Dealer Name`}
                            data={dealerDetails?.dealer_details?.full_name}
                        />
                        <DivLayout
                            heading={`Business Id`}
                            data={dealerDetails?.financial_details?.business_id}
                        />
                        <DivLayout
                            heading={`Brand Name`}
                            data={dealerDetails?.brand_name}
                        />
                        <DivLayout
                            heading={`Email`}
                            data={dealerDetails?.dealer_details?.email}
                        />
                        <DivLayout
                            heading={`Phone`}
                            data={dealerDetails?.dealer_details?.phone_number}
                        />

                        <hr />

                        <div className='row'>
                         <div className="col-md-6">
                           <ConstantInput
                                label={localization.amount}
                                value={""}
                                type="number"
                                handleChange={(val) =>
                                    handleInputList(parseFloat(val), 'amount')
                                }
                                required={true}
                                isStarRequired={true}
                            />
                         </div>  
                         <div className="col-md-6">
                           <ConstantInput
                                label={localization.remark}
                                value={""}
                                type="text"
                                handleChange={(val) =>
                                    handleInputList(val, 'remark')
                                }
                                required={true}
                                isStarRequired={true}
                            />
                         </div>
                         <div className="col-md-6">
                            <FileUpload
                                id={"addAttachment"}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrlPublic}
                                documentUrlData={documentUrlDataPublic}
                                onChange={(val) =>
                                    handleInputList(val, 'attachment')
                                }
                            >
                            <span className="btn btn-transparent">
                                {localization.attachment}
                            </span>
                            </FileUpload>
                         </div> 
                         <div className="col-md-12" style={{'margin':'2rem 0rem 2rem 0rem'}}>
                            <button className="btn btn-primary" onClick={handleSubmitTransaction}>Submit</button>
                         </div>
                        </div>
                    </div>
                </CardSection>
                </>
             ): null 
            }   
            </div>
            </Layout>
        </>
    )
}

export default AddToDealerWallet;